@import '../../../../../node_modules/swiper/swiper.scss';
@import '../../../../../node_modules/swiper/modules/pagination/pagination.scss';
@import '../../../../../node_modules/swiper/modules/scrollbar/scrollbar.scss';

:host {
  @apply block overflow-hidden;
}

:host(.swiper-horizontal-centered) {
  .swiper-wrapper {
    @apply items-center;
  }
}

// Pagination Bullets
// --------------------------------------------------

.swiper-pagination-bullet {
  @apply bg-grey-light;
}

.swiper-pagination-bullet-active {
  @apply bg-berry;
}


// Pagination Progress Bar
// --------------------------------------------------

.swiper-pagination-progressbar {
  @apply bg-grey-light;
}

.swiper-pagination-progressbar .swiper-pagination-progressbar-fill {
  @apply bg-berry;
}

// Scrollbar
// --------------------------------------------------

.swiper-scrollbar {
  @apply bg-grey-light;
}

.swiper-scrollbar-drag {
  @apply bg-berry;
}

// Navigation Arrows
// ---------------------------------------------------

button.swiper-button-prev,
button.swiper-button-next {
  @apply absolute top-1/2 z-[1];

  &[disabled] {
    @apply hidden;
  }
}

button.swiper-button-prev {
  @apply left-4;
}

button.swiper-button-next {
  @apply right-4;
}
